import { Card } from "@mantine/core";
import type { JSX } from "react";
import { ProductCollectionStep } from "@/customer-panel/components/call-intro-flow/steps/product-info/ProductCollectionStep";
import { useCallIntroStore } from "@/customer-panel/components/call-intro-flow/store/CallIntroStore";
import classes from "./CallIntroFlow.module.css";
import { CustomerInfoCollectionStep } from "./steps/customer-info/CustomerInfoCollectionStep";

export function CallIntroFlow(): JSX.Element {
    const currentStep = useCallIntroStore((state) => state.currentStep);
    const pushStep = useCallIntroStore((state) => state.pushStep);
    const popStep = useCallIntroStore((state) => state.popStep);
    return (
        <Card h="100%" bg="dark.5" p="1.2rem" pb="0" className={classes.callIntroFlowCard}>
            {currentStep === "CustomerInfoCollection" && (
                <CustomerInfoCollectionStep onNext={() => pushStep("ProductCollection")} />
            )}
            {currentStep === "ProductCollection" && (
                <ProductCollectionStep onNext={() => pushStep("IntroFlowCompleted")} onPrev={popStep} />
            )}
        </Card>
    );
}
